// extracted by mini-css-extract-plugin
module.exports = {"footer_links_wrapper":"FooterLinks_footer_links_wrapper__e3m1e","list_item":"FooterLinks_list_item__2hMuI","nav_link":"FooterLinks_nav_link__3CbCH"};